export const paymentMessages = {
  sv: {
    methodLabel: "Betalningsmetod",
    selectPlaceholder: "-- Välj --",
    bankName: "Bank",
    clearingCode: "Clearingnummer",
    bicLabel: "BIC",
    reference: "Betalningsreferens",
    holderName: "Kontoinnehavare",
    methodLabels: {
      Bankkonto: "Bankkonto",
      Bankgiro: "Bankgiro",
      Plusgiro: "Plusgiro",
      IBAN: "Utländskt bankkonto (IBAN)",
      Personkonto: "Personkonto",
      Annan: "Annan",
    },
    accountLabels: {
      Bankkonto: "Bankkonto (endast siffror)",
      Bankgiro: "Bankgironummer (ex 1234-5678, 123-4567)",
      Plusgiro: "Plusgironummer (ex 1234567-8)",
      IBAN: "IBAN",
      Personkonto: "Personkontonummer (endast siffror)",
      Annan: "Betalningsinformation",
    },
    validation: {
      methodRequired: "Betalningsmetod",
      bankgiroRequired: "Bankgiro-nummer",
      bankgiroDigits: "Bankgiro-nummer ska bara innehålla siffror",
      bankgiroMin: "Bankgiro-nummer ska minst vara 7 siffror",
      bankgiroMax: "Bankgiro-nummer ska högst vara 8 siffror",
      bankgiroInvalid: "Bankgiro-nummer är felaktigt!",
      bankgiroFormat: "Bankgiro-nummer fel format",
      plusgiroRequired: "Plusgiro-nummer",
      plusgiroDigits: "Plusgiro-nummer ska bara innehålla siffror",
      plusgiroMin: "Plusgiro-nummer ska minst vara 2 siffror",
      plusgiroMax: "Plusgiro-nummer ska högst vara 8 siffror",
      plusgiroInvalid: "Plusgiro-nummer är felaktigt!",
      plusgiroFormat: "Plusgiro-nummer fel format",
      bankAccountRequired: "Kontonummer",
      bankAccountDigits: "Bankkonto ska bara innehålla siffror",
      bankAccountInvalid: "Ogiltigt kontonummer, ange ett giltigt svenskt bankkonto",
      bankNameRequired: "Bank",
      clearingRequired: "Clearingnummer",
      clearingDigits: "Clearingnummer ska bara innehålla siffror",
      clearingLength: "Clearingnummer ska vara 4 eller 5 siffror",
      ibanRequired: "IBAN",
      ibanFormat: "IBAN ska börja med landskod (2 bokstäver) och kontrollsiffror (2 siffror)",
      ibanMin: "IBAN måste vara minst 15 tecken",
      ibanMax: "IBAN får vara högst 34 tecken",
      ibanInvalid: "Felaktigt BIC/IBAN",
      bicRequired: "BIC",
      bicLength: "BIC ska vara 8 eller 11 tecken",
      bicFormat: "BIC måste ha formatet: 4 bokstäver (bank) + 2 bokstäver (land) + 2 tecken (plats)",
      holderNameRequired: "Kontoinnehavare krävs",
      holderNameFormat: "Kontoinnehavare får bara innehålla latinska tecken",
      referenceFormat: "Felaktig betalningsreferens",
      annanRequired: "Betalningsinformation",
    },
  },
  en: {
    methodLabel: "Payment method",
    selectPlaceholder: "-- select --",
    bankName: "Bank",
    clearingCode: "Clearing number",
    bicLabel: "BIC/SWIFT",
    reference: "Payment reference",
    holderName: "Account Holder Name",
    methodLabels: {
      Bankkonto: "Swedish bank account",
      Bankgiro: "Swedish Bankgiro",
      Plusgiro: "Swedish Plusgiro",
      IBAN: "BIC/SWIFT/IBAN",
      Personkonto: "Personkonto",
      Annan: "Other",
    },
    accountLabels: {
      Bankkonto: "Bank account (digits only)",
      Bankgiro: "Bankgiro number (e.g. 1234-5678, 123-4567)",
      Plusgiro: "Plusgiro number (e.g. 1234567-8)",
      IBAN: "IBAN",
      Personkonto: "Personal account number (digits only)",
      Annan: "Payment information",
    },
    validation: {
      methodRequired: "Payment method is not selected",
      bankgiroRequired: "Bankgiro number is required",
      bankgiroDigits: "Bankgiro number must only be digits",
      bankgiroMin: "Bankgiro number must be atleast 7 digits",
      bankgiroMax: "Bankgiro must be atmost 8 digits",
      bankgiroInvalid: "Bankgiro number is not correct",
      bankgiroFormat: "Bankgiro number has wrong format",
      plusgiroRequired: "Plusgiro number is required",
      plusgiroDigits: "Plusgiro must only be digits",
      plusgiroMin: "Plusgiro number must be atleast 2 digits",
      plusgiroMax: "Plusgiro number must be atmost 8 digits",
      plusgiroInvalid: "Plusgiro number is not correct",
      plusgiroFormat: "Plusgiro number has wrong format",
      bankAccountRequired: "Account number is required",
      bankAccountDigits: "Bank account number must be digits only",
      bankAccountInvalid: "Clearing code and bank account number does not match",
      bankNameRequired: "Bank name is required",
      clearingRequired: "Clearing number is required",
      clearingDigits: "Clearing number must only be digits",
      clearingLength: "Clearing number must be 4 or 5 digits",
      ibanRequired: "IBAN is required",
      ibanFormat: "IBAN must start with country code (2 letters) and check digits (2 digits)",
      ibanMin: "IBAN must be at least 15 characters",
      ibanMax: "IBAN must be at most 34 characters",
      ibanInvalid: "bad bic/account",
      bicRequired: "BIC/SWIFT is required",
      bicLength: "BIC must be 8 or 11 characters",
      bicFormat: "BIC must have the format: 4 letters (bank) + 2 letters (country) + 2 characters (location)",
      holderNameRequired: "Bank account holder name is required",
      holderNameFormat: "Bank account holder name must be latin characters",
      referenceFormat: "Bad payment reference",
      annanRequired: "Payment information is required",
    },
  },
};
